module.exports = __webpack_public_path__ + "img/exit.df74f11a.svg";